import { Box, Typography, Button, Tooltip } from "@mui/material";
import { ActionBar } from "@redriver/cinnamon-mui";
import { ExternalLink } from "components/navigation";
import GlobalSearch from "./GlobalSearch";
import Settings from "./Settings";
import CinnamonIcon from "assets/cinnamon-icon.png";
import RedRiverIcon from "assets/rr-icon.png";
import GitHubIcon from "@mui/icons-material/GitHub";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SettingsIcon from "@mui/icons-material/Settings";
import Package from "../../package.json";

const currentVersion = Package?.dependencies?.["@redriver/cinnamon-mui"];

const Header = () => (
  <Box
    sx={{
      height: "65px",
      padding: "12px",
      backgroundColor: "background.white",
      borderBottomStyle: "solid",
      borderBottomWidth: 1,
      borderBottomColor: "grey.300",
    }}
  >
    <ActionBar spacing={2} verticalAlign="middle">
      <ActionBar.Item sx={{ height: "40px" }}>
        <img src={CinnamonIcon} alt="Cinnamon" height="40" />
      </ActionBar.Item>
      <ActionBar.Item>
        <Typography variant="subtitle1">Cinnamon MUI</Typography>
      </ActionBar.Item>
      {typeof currentVersion === "string" && (
        <ActionBar.Item fluid>
          <Typography variant="subtitle1">v{currentVersion}</Typography>
        </ActionBar.Item>
      )}
      <ActionBar.Item>
        <GlobalSearch />
      </ActionBar.Item>
      <ActionBar.Item>
        <HeaderButton
          component={ExternalLink}
          href="https://github.com/RedRiverSoftware/Cinnamon"
          title="GitHub"
        >
          <GitHubIcon />
        </HeaderButton>
      </ActionBar.Item>
      <ActionBar.Item>
        <HeaderButton
          component={ExternalLink}
          href="https://github.com/RedRiverSoftware/Cinnamon/wiki"
          title="Wiki"
        >
          <MenuBookIcon />
        </HeaderButton>
      </ActionBar.Item>
      <ActionBar.Item>
        <Settings as={HeaderButton} title="Settings">
          <SettingsIcon />
        </Settings>
      </ActionBar.Item>
      <ActionBar.Item sx={{ height: "40px" }}>
        <img src={RedRiverIcon} alt="Red River" height="40" />
      </ActionBar.Item>
    </ActionBar>
  </Box>
);

const HeaderButton = ({ title, ...props }) => (
  <Tooltip title={title}>
    <Button
      {...props}
      variant="outlined"
      color="primary"
      sx={{
        minWidth: "unset",
        width: "40px",
        height: "40px",
        borderRadius: "8px",
      }}
    />
  </Tooltip>
);

export default Header;
